<template>
	<div class="content__column content__column--small">
		<h1 class="content__title">Lista de Items</h1>
		<div class="results" v-if="items">
			<div class="results__element" v-for="(item, index) in items" :key="index">
				<div class="results__info">
					<h2 class="results__title">{{ item.color_es }} - {{ item.size_es }}</h2>
					<p class="results__text">Cantidad disponible: {{ item.quantity }}</p>
				</div>
				<div class="results__actions">
					<button @click.prevent="$parent.$emit('edit', item.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--edit">Editar Item</button>
					<button @click.prevent="deleteItem(item.id)" class="btn btn__icon btn__icon--regular results__btn results__btn--delete">Borrar Item</button>
				</div>
			</div>
		</div>
		<div class="information" v-else>
			<p class="information__text">No se encontraron resultados</p>
		</div>
		<confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
	</div>
</template>

<script>
	import httpService from '@/core/api/request'
	import confirmation from '@/components/layout/confirmation'
	export default {
		props: {
			filters: {
				type: String,
				required: false,
				default: function() {
					return ''
				}
			}
		},
		mixins: [httpService],
		components: { confirmation },
		data: function() {
			return {
				itemId: null,
				items: null,
				confirm: false,
				productId: null
			}
		},
		created: function() {
			this.productId = this.$route.params.id
			this.getItems()
		},
		mounted: function() {
			this.$on('continue', () => {
				this.confirm = false
				this.proccedToDelete()
			})
		},
		watch: {
			filters: function() {
				this.getItems()
			},
			'$store.state.elementChanged': function() {
				this.getItems()
			}
		},
		methods: {
			getItems: function() {
				let httpRequest = {
					params: '?' + this.filters + '&product_id=eq:' + this.productId,
					module: 'inventory'
				}
				this.get(httpRequest)
					.then(items => {
						this.items = items.data
					})
					.catch(() => {
						this.items = null
					})
			},
			deleteItem: function(id) {
				this.confirm = true
				this.itemId = id
			},
			proccedToDelete: function() {
				let httpRequest = {
					params: '',
					module: 'inventory'
				}
				this.delete(this.itemId, httpRequest)
					.then(response => {
						this.itemId = null
						this.getItems()
						this.$store.commit('notificate', {
							title: 'ITEM BORRADO',
							text: 'El item ha sido borrado correctamente',
							type: 'success'
						})
					})
					.catch(error => {
						this.$store.commit('notificate', {
							title: 'ITEM NO BORRADO',
							text: 'No se pudo borrar el item seleccionado, por favor intente más tarde',
							type: 'warn'
						})
					})
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/inventory/list.vue